<script>
import api from '@/helpers/api'
import Multiselect from 'vue-multiselect'
export default {
  name: 'customer-select',
  props: { value: { type: String } },
  components: { Multiselect },
  data: vm => ({
    customers: [],
    selected: null
  }),
  methods: {
    async init () {
      let { items } = await api.customers.fetchPage({
        page: 1,
        pageSize: -1
      })

      this.customers = [...items]
      this.selected = this.customers.find(c => c.id === this.value)
    },
    onSelected (customer) {
      this.$emit('input', customer ? customer.id : null)
      this.$emit('select', customer)
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    value: {
      handler: 'init',
      immediate: true
    }
  },
  computed: {
    listeners () {
      return { ...this.$listeners, select: 'onSelected' }
    }
  }
}
</script>
<template>
  <Multiselect
    :options="customers"
    :custom-label="
      ({ id, company_name, number }) => `${company_name} (${number})`
    "
    track-by="id"
    v-model="selected"
    :placeholder="$attrs.placeholder || 'Select a Customer'"
    :show-labels="false"
    :allow-empty="false"
    v-bind="$attrs"
    @input="onSelected"
    v-on:close="$emit('blur')"
  ></Multiselect>
</template>

<style lang="scss">
.multiselect__content-wrapper {
  overflow-x: hidden;
}
</style>
